import { render, staticRenderFns } from "./RenderedImage.vue?vue&type=template&id=1ff4d0c2&scoped=true"
import script from "./RenderedImage.vue?vue&type=script&lang=ts"
export * from "./RenderedImage.vue?vue&type=script&lang=ts"
import style0 from "./RenderedImage.vue?vue&type=style&index=0&id=1ff4d0c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ff4d0c2",
  null
  
)

export default component.exports